import { createAction, handleActions } from "redux-actions";

import {
  api
} from "../../services";

import {
  promotionInterface,
  PromotionPackageInterface,
  rootReducerInterface,
} from "../../typings/interfaces";

import { mapModuleToEn } from "../LanguageMapper";

const PROMOTION_PACKAGES_GET = "PROMOTION_PACKAGES_GET";

// ACTIONS

// Get module promotions
export const getPromotionPackages = createAction(
  PROMOTION_PACKAGES_GET,
  async (
    module: string,
    callback?: (promotionPackages: PromotionPackageInterface[] | Boolean) => void
  ) => {
    try {
      const promotionPackages = await api.Promotion.list(
        { module: mapModuleToEn(module) }
      );

      if (promotionPackages.length == 0) {
        callback && callback(false);
        return [];
      }

      callback && callback(promotionPackages);
      return promotionPackages;
    } catch (error) {
      callback && callback(false);
      return [];
    }
  }
);

// SELECTORS
export const selectPromotionPackages = (state: rootReducerInterface) =>
  state.promotion.packages;

// INITIAL STATE
const initialState: promotionInterface = {
  packages: [],
};

// REDUCERS
const promotionReducers = {
  setPromotionPackages: (state: promotionInterface, { payload }) => ({
    ...state,
    packages: !payload ? [] : [...payload]
  }),
};

export default handleActions(
  {
    [PROMOTION_PACKAGES_GET]: promotionReducers.setPromotionPackages,
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/routes/Promotion/promotion.ducks.ts